import { StyledStatusesContainer } from './MessageItem.styled';
import StatusCheck from './StatusCheck';

interface Props {
    status: StatusesEnum;
}

export enum StatusesEnum {
    DELIVERED = 'DELIVERED',
    READ = 'READ',
    SENT = 'SENT',
}

export default function MessageStatuses(props: Props) {
    const { status } = props;

    const statusChecks = () => {
        switch (status) {
            case 'DELIVERED':
                return (
                    <>
                        <StatusCheck />
                        <StatusCheck />
                    </>
                );
            case 'READ':
                return (
                    <>
                        <StatusCheck read={true} />
                        <StatusCheck read={true} />
                    </>
                );
            case 'SENT':
                return (
                    <>
                        <StatusCheck />
                    </>
                );
        }
    };

    return <StyledStatusesContainer>{statusChecks()}</StyledStatusesContainer>;
}
